module.exports = __webpack_public_path__ + "static/media/background.99ce9b9c.png";